// extracted by mini-css-extract-plugin
export default {"hello":"Notification_hello__xhBKv","notistack-MuiContent":"Notification_notistack-MuiContent__qS8rn"};